export default "__VITE_ASSET__XdnA67oS__"